import store from "@/store";
import {User} from "./users";

export const canEditUserRights = (
  user: User | undefined,
  targetRole: "MANAGERS" | "GUESTS" | null,
  targetUserId?: number,
): boolean => {
  if (!user || user.isAdmin) {
    return false;
  }

  if (targetRole === "MANAGERS") {
    return store.getters.canDoInEnvCompany("EDIT_MANAGERS_RIGHTS");
  }

  if (targetRole === "GUESTS") {
    const canDo = store.getters.canDoInEnvCompany("EDIT_GUESTS_RIGHTS");
    return targetUserId ? user.id !== targetUserId && canDo : canDo;
  }

  return false;
};
